import firebase from 'firebase'
// Initialize Firebase
const config = {
  apiKey: "AIzaSyBQiAj-0uj-THpynphPqmQ39v_Zrp7SJ28",
  authDomain: "pe-locker.firebaseapp.com",
  projectId: "pe-locker",
  storageBucket: "pe-locker.appspot.com",
  databaseURL: "https://pe-locker-default-rtdb.firebaseio.com",
  messagingSenderId: "1070904953801",
  appId: "1:1070904953801:web:f5125015583a1b82dcf618",
  measurementId: "G-4GB9H074ZZ"
};
  firebase.initializeApp(config);
export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js